<template>
    <div style="width: 100%;height: 100vh;overflow: hidden;background-size:100% 100%;background-repeat: no-repeat;">
        <!-- 头像 -->
        <p v-if="userform.auName" style="margin: 20px;color: #409EFF;">{{ userform.auDepartment }} ---- {{
            userform.auName
            }}
        </p>
        <div style="width: 100px;height: 100px;border-radius: 15px;border:1px solid black;margin: 150px auto 20px;overflow: hidden;"
            v-if="userform.auName">
            <el-image v-if="userform.auHeader" style="width: 100px; height: 100px" :src="userform.auHeader"
                :preview-src-list="[userform.auHeader]">
            </el-image>
            <!-- <img :src="userform.auHeader" alt="" style="border-radius: 15px;" width="100px" height="100px"> -->
        </div>
        <div style="width: 15%;margin:15px auto;text-align: center;" v-if="userform.auName">
            <label class="btn" for="upload2">上传</label>
            <input type="file" id="upload2" style="position:absolute; clip:rect(0 0 0 0);"
                accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 2)">
        </div>
        <div style="width: 100%;height: 100%;position: fixed;top: 0;left: 0;background-color: white;" v-if="IsCropper">
            <div class="wrapper">

                <div class="content" style="margin-top: 20px;">
                    <div class="show-info">
                        <div class="test">
                            <vueCropper ref="cropper" :img="option.img" :outputSize="option.outputSize"
                                :outputType="option.outputType" :info="option.info" :canScale="option.canScale"
                                :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
                                :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox"
                                :fixed="option.fixed" :fixedNumber="option.fixedNumber" :canMove="option.canMove"
                                :canMoveBox="option.canMoveBox" :original="option.original"
                                :centerBox="option.centerBox" :infoTrue="option.infoTrue" :full="option.full"
                                :enlarge="option.enlarge" :mode="option.mode"></vueCropper>
                        </div>
                        <button @click="finish()" class="btn">预览</button>
                        <!-- <button @click="downLoad()" class="btn">下载</button> -->
                        <button @click="ok()" class="btn">确认上传</button>
                        <label class="btn" for="upload2">重新选择</label>
                        <input type="file" id="upload2" style="position:absolute; clip:rect(0 0 0 0);"
                            accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 2)">
                    </div>
                </div>
                <div style="width: 100%;margin-top: 10px;display: flex;align-items: center;margin-left: 80px;"
                    v-show="model">
                    <div>
                        裁剪后的图片:
                    </div>
                    <div class="model-show" @click="model = false"
                        style="margin-left: 20px;border-radius: 1px solid #909399;overflow: hidden;">
                        <el-image style="width: 100px; height: 100px" :src="modelSrc" :preview-src-list="[modelSrc]">
                        </el-image>
                        <!-- <img :src="modelSrc" alt="" style="border-radius: 10px;" width="100px" height="100px"> -->
                    </div>
                </div>

            </div>
        </div>
        <div style="width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);
    position: fixed;top: 0;display: flex;align-items: center;justify-content: center;" v-if="userLogin">
            <div style="width: 60%;height: 37%;background-color: white;border-radius: 23px;padding: 10px;">
                <div style="width: 60%;margin: 15px auto;font-size: 18px;color: #409EFF;text-align: center;">登录</div>
                <el-form ref="form" :model="form" label-position="left" style="height:100%">
                    <el-form-item label="姓名">
                        <el-input v-model="form.auName" style="width: 100%;height: 50px;" placeholder="请输入"
                            size="medium"></el-input>
                    </el-form-item>
                    <div style="margin: 10px auto;width: 60%;">
                        <el-button type="success" round @click="submit">提交登录</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import COS from 'cos-js-sdk-v5';
import {
    getAjUserExist, updateAjUserHeader, uploadFileToTxCloudInterview, getPolicyTxCloudInterview
} from "../../api/api";
export default {
    name: 'HomePage',
    components: {

    },
    data() {
        return {
            IsCropper: false,
            fileList: [{ name: '', url: '' }],
            model: false,
            modelSrc: '',
            crap: false,
            previews: {},
            form: {
                head: ''
            },
            option: {
                img: '', // 裁剪图片的地址 url 地址, base64, blob
                outputSize: 1, // 裁剪生成图片的质量
                outputType: 'png', // 裁剪生成图片的格式 jpeg, png, webp
                info: true, // 裁剪框的大小信息
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 200, // 默认生成截图框宽度
                autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [1, 1], // 截图框的宽高比例 [ 宽度 , 高度 ]
                canMove: true, // 上传图片是否可以移动
                canMoveBox: true, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                full: true, // 是否输出原图比例的截图
                enlarge: '1', // 图片根据截图框输出比例倍数
                mode: 'contain' // 图片默认渲染方式 contain , cover, 100px, 100% auto
            },
            status: '',
            LongGamearr: [],
            isGameShow: false,
            redBagarr: [],
            Longarr: [],
            gameid: 1,
            isShow: false,
            userform: {},
            form: {
                auName: '',
            },
            userLogin: true,
            departmentlist: [],
            bgImg: require('../../assets/bg.png')
        }
    },
    watch: {},
    activated() {

    },
    created() {
        document.title = '收集头像';
        this.init(this.option)
    },
    methods: {
        openLoading() {
            //loading请求等待
            var that = this
            that.loadings = that.$loading({
                lock: true,
                text: that.loadingtext,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        getTenXunCloudKey() {
            return new Promise((resolve, reject) => {
                getPolicyTxCloudInterview().then(res => {
                    if (res.data) {
                        resolve(res.data)
                    }
                })
            })
        },
        // 秘钥初始化
        getCosInIt() {
            const cos = new COS({
                SimpleUploadMethod: 'putObject', // 强烈建议，高级上传、批量上传内部对小文件做简单上传时使用putObject,sdk版本至少需要v1.3.0
                getAuthorization: async (options, callback) => {
                    // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
                    // 异步获取临时密钥
                    // 服务端 JS 示例：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
                    // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
                    // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
                    const data = await this.getTenXunCloudKey();
                    callback({
                        TmpSecretId: data.tmpSecretId,
                        TmpSecretKey: data.tmpSecretKey,
                        // v1.2.0之前版本的 SDK 使用 XCosSecurityToken 而不是 SecurityToken
                        SecurityToken: data.sessionToken,
                        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                        StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
                        ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
                    });
                }
            });
            return cos
        },
        // 腾讯云对象存储上传
        async TenXunCloudUploadFile(file) {
            var that = this
            return new Promise(async (resolve, reject) => {
                const key = await this.getTenXunCloudKey()
                const cos = this.getCosInIt()

                const fileName = this.userform.auId + '_' + new Date().getTime()
                const fileType = file.type.split('/')

                cos.uploadFile({
                    Bucket: key.bucket, // 填写自己的 bucket，必须字段
                    Region: key.region, // 存储桶所在地域，必须字段
                    Key: key.filePath + '/' + fileName + '.' + fileType[fileType.length - 1], // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
                    Body: file,
                    /* v1.4.3之前的版本必须，v1.4.3及以后的版本非必须 */
                    SliceSize: 1024 * 1024 * 5, // 触发分块上传的阈值，超过5MB 使用分块上传，小于5MB使用简单上传。可自行设置
                    onProgress: function (progressData) {
                        console.log('上传进度：', progressData);
                        const loadingtext = '上传中...' + progressData.percent * 100 + '%';
                        if (that.loadings) {
                            that.loadings.setText(loadingtext);
                        } else {
                            // 首次创建loading实例
                            that.loadings = that.$loading({
                                lock: true,
                                text: loadingtext,
                                spinner: "el-icon-loading",
                                background: "rgba(0, 0, 0, 0.7)"
                            });
                        }
                        // that.loadings.close()
                        console.log(that.loadingtext);

                    },
                }).then(data => {
                    console.log('上传成功', data);
                    const url = key.baseHttp + key.filePath + '/' + fileName + '.' + fileType[fileType.length - 1]
                    // resolve(url)
                    const fileobj = {
                        fileName: file.name,
                        fileurl: url
                    }
                    //console.log(fileobj);
                    return resolve(fileobj)
                }).catch(err => {
                    console.log('上传出错', err);
                });
            })
        },
        //裁剪
        finish() {
            this.$refs.cropper.getCropData((data) => {
                this.modelSrc = data
                this.model = true;
                //裁剪后的图片显示
                // this.option.img = this.modelSrc;
            })
        },
        //下载
        downLoad() {
            if (this.modelSrc == '') {
                console.log('请先选择图片！')
                return
            }
            let url = this.modelSrc
            fetch(url).then(res => res.blob()).then(blob => {//将链接字符地址转换成blob地址
                const aLink = document.createElement('a')
                aLink.href = URL.createObjectURL(blob)
                aLink.download = Date.now() + '.png'
                document.body.appendChild(aLink)
                aLink.click()
                aLink.remove()
            })
        },
        ok() {
            var that = this
            that.$confirm('确认选择该图片为头像?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$refs.cropper.getCropBlob(async data => {
                    // 这里data数据为Blob类型，blobToDataURI方法转换成base64
                    const url = await that.TenXunCloudUploadFile(data)
                    console.log(data, url);
                    updateAjUserHeader({ auId: that.userform.auId, auHeader: url.fileurl }).then(res => {
                        if (res.data) {
                            that.userform = res.data;
                            that.$set(this,'userform',res.data)
                            that.IsCropper = false;
                            that.$message({
                                type: 'success',
                                message: '提交成功!'
                            });
                            that.loadings.close()
                        }

                    })
                    // this.blobToDataURI(data, function (res) {
                    //     console.log('base64格式：', res)
                    // })
                })

            }).catch(() => {
                that.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        MoveTheCloud(file) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file);

                uploadFileToTxCloudInterview(formData).then(res => {
                    if (res.status == 200) {
                        const fileobj = {
                            fileName: Date.now(),
                            fileurl: res.data
                        }
                        console.log(fileobj);
                        return resolve(fileobj)
                    } else {
                        reject(new Error('上传失败'))
                    }
                }).catch(err => {
                    reject(err)
                })
            })

        },
        //上传图片
        uploadImg(e, num) {
            this.option.img = ''
            var file = e.target.files[0]
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
                return false
            }
            this.theFile=file
            var reader = new FileReader()
            reader.onload = (e) => {
                let data = e.target.result
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                if (num === 1) {
                    this.option.img = data
                } else if (num === 2) {
                    this.option.img = data
                    this.IsCropper = true;
                }
            }
            // 转化为blob
            reader.readAsArrayBuffer(file)
        },
        //url转base64
        blobToDataURI(blob, callback) {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function (e) {
                callback(e.target.result);
            }
        },

        cleanLocation() {
            localStorage.removeItem('userdynamic');
            location.reload()
        },

        submit() {
            getAjUserExist(this.form).then(res => {
                if (res.data) {
                    this.userLogin = false;
                    this.userform = res.data;
                    alert('登录成功')
                    console.log(this.userform);
                }

            })
        },
        //初始化
        init(obj) {
            if (obj.img) {
                this.option.img = obj.img
            }
            //裁剪生成图片的质量
            if (obj.outputSize) {
                this.option.outputSize = obj.outputSize
            } else {
                this.option.outputSize = 1
            }
            //裁剪生成图片的格式
            if (obj.outputType) {
                this.option.outputType = obj.outputType
            } else {
                this.option.outputType = 'jpeg'
            }
            //裁剪框的大小信息
            if (obj.info) {
                this.option.info = obj.info
            } else {
                this.option.info = true
            }
            //图片是否允许滚轮缩放
            if (obj.canScale) {
                this.option.canScale = obj.canScale
            } else {
                this.option.canScale = false
            }
            //是否默认生成截图框
            if (obj.autoCrop) {
                this.option.autoCrop = obj.autoCrop
            } else {
                this.option.autoCrop = true
            }
            //默认生成截图框宽度
            if (obj.autoCropWidth) {
                this.option.autoCropWidth = obj.autoCropWidth
            } else {
                this.option.autoCropWidth = 375
            }
            //默认生成截图框高度
            if (obj.autoCropHeight) {
                this.option.autoCropHeight = obj.autoCropHeight
            } else {
                this.option.autoCropHeight = 245
            }
            //固定截图框大小 不允许改变
            if (obj.fixedBox) {
                this.option.fixedBox = obj.fixedBox
            } else {
                this.option.fixedBox = false
            }
            //是否开启截图框宽高固定比例
            if (obj.fixed) {
                this.option.fixed = obj.fixed
            } else {
                this.option.fixed = true
            }
            //截图框的宽高比例
            if (obj.fixedNumber) {
                this.option.fixedNumber = obj.fixedNumber
            } else {
                this.option.fixedNumber = [this.option.autoCropWidth, this.option.autoCropHeight]
            }
            //上传图片是否可以移动
            if (obj.canMove) {
                this.option.canMove = obj.canMove
            } else {
                this.option.canMove = true
            }
            //截图框能否拖动
            if (obj.canMoveBox) {
                this.option.canMoveBox = obj.canMoveBox
            } else {
                this.option.canMoveBox = true
            }
            //上传图片按照原始比例渲染
            if (obj.original) {
                this.option.original = obj.original
            } else {
                this.option.original = false
            }
            //截图框是否被限制在图片里面
            if (obj.centerBox) {
                this.option.centerBox = obj.centerBox
            } else {
                this.option.centerBox = true
            }
            //true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            if (obj.infoTrue) {
                this.option.infoTrue = obj.infoTrue
            } else {
                this.option.infoTrue = true
            }
            //是否输出原图比例的截图
            if (obj.full) {
                this.option.full = obj.full
            } else {
                this.option.full = true
            }
            //图片根据截图框输出比例倍数
            if (obj.enlarge) {
                this.option.enlarge = obj.enlarge
            } else {
                this.option.enlarge = '1'
            }
            //图片默认渲染方式
            if (obj.mode) {
                this.option.mode = obj.mode
            } else {
                this.option.mode = 'contain'
            }
            if (obj.success) {
                this.success = obj.success
            } else {
                this.success = () => {
                }
            }
        },
    }
}
</script>

<style scoped>
div /deep/ .el-input--medium .el-input__inner {
    min-height: 10vw;
    line-height: 10vw;
    font-size: 0.6rem;
    text-align: center;
}

div /deep/ .el-form-item__label {
    font-size: 0.6rem;
    padding: 10px 10px
}

div /deep/ .el-button.is-round {
    border-radius: 9.667vw;
    padding: 2.6vw 8.067vw;
}

div /deep/ .el-select .el-input__inner {
    min-height: 10vw;
    line-height: 10vw;
    text-align: center;
    font-size: 0.6rem;
}

div /deep/ .popCLs .el-select-dropdown__item {
    min-height: 10vw !important;
    line-height: 10vw;
    font-size: 0.5rem;
}

* {
    margin: 0;
    padding: 0;
}

.content {
    margin: auto;
    max-width: 585px;
    margin-bottom: 100px;
}

.test-button {
    display: flex;
    flex-wrap: wrap;
}

.btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c0ccda;
    color: #1f2d3d;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 20px 10px 0px 0px;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #50bfff;
    border-color: #50bfff;
    transition: all .2s ease;
    text-decoration: none;
    user-select: none;
}

.des {
    line-height: 30px;
}

code.language-html {
    padding: 10px 20px;
    margin: 10px 0px;
    display: block;
    background-color: #333;
    color: #fff;
    overflow-x: auto;
    font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo, Lucida, Sans, Type, Writer, Ubuntu, Mono;
    border-radius: 5px;
    white-space: pre;
}

.show-info {
    margin-bottom: 50px;
}

.show-info h2 {
    line-height: 50px;
}

.test {
    height: 285px;
}

.model {
    position: fixed;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
}

.model-show {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
}

.model img {
    display: block;
    margin: auto;
    max-width: 80%;
    user-select: none;
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%), linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
}

.c-item {
    display: block;
    padding: 10px 0;
    user-select: none;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1000px) {
    .content {
        max-width: 90%;
        margin: auto;
    }

    .test {
        height: 400px;
    }
}
</style>
